import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getAssetTypeFromUrl } from '@/helpers';
import { StreamCoverPhotoProps } from '@/types';

export const StreamCoverPhoto = ({
  coverPhotoUrl,
  waitingForStreamText
}: StreamCoverPhotoProps) => {
  const [isVerticalImage, setIsVerticalImage] = useState(false);
  const [t] = useTranslation('common');
  const [assetType, setAssetType] = useState<'image' | 'video'>('image');

  useEffect(() => {
    if (!coverPhotoUrl) {
      return;
    }

    const type = getAssetTypeFromUrl(coverPhotoUrl);
    setAssetType(type);

    if (type === 'image') {
      const img = new Image();
      img.src = coverPhotoUrl;

      img.onload = () => {
        const isVertical = img.height > img.width;
        setIsVerticalImage(isVertical);
      };
    }
  }, [coverPhotoUrl]);

  return (
    <div className='flex w-full flex-col gap-y-9'>
      <>
        <div className='relative aspect-video w-full rounded-2xl bg-primary-white text-lg'>
          {assetType === 'image' ? (
            <img
              src={coverPhotoUrl}
              className={`aspect-video w-full rounded-2xl object-contain ${
                isVerticalImage ? 'object-contain' : 'object-fill'
              }`}
            />
          ) : (
            <video
              src={coverPhotoUrl}
              className={'aspect-video w-full rounded-2xl object-contain'}
              autoPlay
              loop
              muted
              playsInline
            />
          )}
          <div className='absolute top-0 w-full rounded-t-2xl bg-primary-gray px-2 sm:py-4 md:py-1 lg:py-4'>
            <span className='text-xs md:text-lg'>{t(waitingForStreamText)}</span>
          </div>
        </div>
      </>
    </div>
  );
};
